import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import cx from 'classnames'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import extract, {sanitize, replace} from '../../core/extract'
import logoPerfimmo from '../resources/img/logo-perfimmo.png'
import logoActradis from '../resources/img/logo-actradis.png'
import logoBatiref from '../resources/img/logo-batiref.png'
import i18n from '../i18n'
import style from './ProviderScores.less'

function actradisStatus(reportState) {
    switch(reportState) {
        case 'OK': return 'success'
        case 'DocumentExpiredInLessThan15Days': return 'warning'
        case 'DocumentExpired': return 'danger'
        default: return 'default'
    }
}

class ProviderScores extends Component {

    static propTypes = {
    }

    render() {
        const {dispatch, actradisProvider, _appLinks} = this.props

        const brandStyle = _appLinks.find(linkFinder('actradis/providercompanies')) && {width: '33%'} || {width: '50%'}

        const actradisTooltip = (text, reportState) => {
            return (
                <Tooltip className={'tooltip-' + actradisStatus(reportState)}>
                    <span>{replace(extract(i18n.actradisReportStateEnum, reportState || 'noDocument'), {text})}</span>
                </Tooltip>
            )
        }

        return (
            <div className={style.default}>
                <h4>{i18n.scores}</h4>
                <div className={style.brandGroup}>
                    <div
                        className={cx(style.brand, style.batiref)}
                        style={brandStyle}>
                        <div className={style.count}>
                            <span>---</span>
                            <small>---</small>
                        </div>
                        <img src={logoBatiref} />
                        <small>{i18n.batiref}</small>
                    </div>
                    {_appLinks.find(linkFinder('actradis/providercompanies')) && (
                        <div
                            className={cx(style.brand, style.actradis)}
                            style={brandStyle}>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={actradisTooltip(i18n.undeclaredWorkReportState.sm, actradisProvider && actradisProvider.undeclaredWorkReportState)}>
                                <div className={cx(style.count, style[sanitize(actradisProvider && actradisProvider.undeclaredWorkReportState)])}>
                                    <span></span>
                                    <small>{i18n.undeclaredWorkReportState.xs}</small>
                                </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={actradisTooltip(i18n.insuranceReportState.sm, actradisProvider && actradisProvider.insuranceReportState)}>
                                <div className={cx(style.count, style[sanitize(actradisProvider && actradisProvider.insuranceReportState)])}>
                                    <span></span>
                                    <small>{i18n.insuranceReportState.xs}</small>
                                </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={actradisTooltip(i18n.specificDocumentsReportState.sm, actradisProvider && actradisProvider.specificDocumentsReportState)}>
                                <div className={cx(style.count, style[sanitize(actradisProvider && actradisProvider.specificDocumentsReportState)])}>
                                    <span></span>
                                    <small>{i18n.specificDocumentsReportState.xs}</small>
                                </div>
                            </OverlayTrigger>
                            <img src={logoActradis} />
                            <small>{i18n.actradis}</small>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

ProviderScores = connect((state) => ({
    actradisProvider: state.actradis.provider.provider,
    _appLinks: state.app._links
}))(ProviderScores)

export default ProviderScores


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderScores.js